import { types } from "../types/types";

const initialState = null;

export const graphicalReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.loadui:
            return { ...action.payload }

        default:
            return state;
    }
}
